import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMessage } from './message';

import DieToolService from '../services/die-tool.service';


export const fetchDieToolList = createAsyncThunk(
    'dieTool/fetchDieToolList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await DieToolService.getDieToolList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

export const fetchArchivedDieToolist = createAsyncThunk(
    'dieProfile/fetchArchiveDieToolList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await DieToolService.getDieArchiveToolList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);
export const fetchDieToolDetails = createAsyncThunk(
    'dieTool/fetchDieToolDetails',
    async (id, { rejectWithValue }) => {
        try {
            const response = await DieToolService.getDieToolDetails(id);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const fetchDieToolById = createAsyncThunk(
    'dieTool/fetchById',
    async (dieToolId, { rejectWithValue }) => {
        try {
            const response = await DieToolService.getDieToolById(dieToolId);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const fetchDieToolByDieProfileId = createAsyncThunk(
    'dieTool/fetchByProfileId',
    async ({ dieId, page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await DieToolService.getDieToolListByDieId(dieId, page, pagesize, search, ordering);
            return response.data; // Return the profile data
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const fetchToolByProfileId = createAsyncThunk(
    'dieTool/fetchToolByProfileId',
    async ({ id, page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await DieToolService.getToolListByProfileId(id, page, pagesize, search, ordering);
            return response.data; // Return the profile data
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const createDieTool = createAsyncThunk(
    'dieTool/createDieTool',
    async ({ values }, thunkAPI) => {
        try {
            const textPayload = {
                die: values.die.value,
                tool_number: values.tool_number,
                current_kg: values.current_kg,
                die_size: values.die_size, // Ensure numeric values
                die_cavity: values.die_cavity,
                developer: values.developer,
                die_option: values.die_option,
                diameter: values.diameter,
                thickness: values.thickness,
                backer_number: values.backer_number,
                rac_no: values.rac_no,
                row_no: values.row_no,
                column_no: values.column_no,
                die_location: values.die_location,
                developer_ref_no: values.developer_ref_no,
                received_date: values.received_date,
                order_date: values.order_date,
                total_running_qty: values.total_running_qty,
                total_running_ton: values.total_running_ton ?? 0,
                drawing_no: values.drawing_no,
                eligible_bloster: values.eligible_bloster,
                eligible_for_press: values.eligible_for_press,
                purchase_price: values.purchase_price,
                run_under_deviation: values.run_under_deviation,
                run_under_deviation_inactive: values.run_under_deviation_inactive,
                run_under_deviation_reason: values.run_under_deviation_reason,
                ownership: values.ownership,
                is_active: values.is_active,
                remarks: values.remarks,
            };
            const response = await DieToolService.addDieTool(textPayload);
            return response.data; // Assuming response contains the created die group data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const createProfileDieTool = createAsyncThunk(
    'dieTool/createDieTool',
    async ({ values }, thunkAPI) => {
        try {
            const textPayload = {
                die: values.die,
                tool_number: values.tool_number,
                current_kg: values.current_kg,
                die_size: values.die_size, // Ensure numeric values
                die_cavity: values.die_cavity,
                developer: values.developer,
                die_option: values.die_option,
                diameter: values.diameter,
                thickness: values.thickness,
                backer_number: values.backer_number,
                rac_no: values.rac_no,
                row_no: values.row_no,
                column_no: values.column_no,
                die_location: values.die_location,
                developer_ref_no: values.developer_ref_no,
                received_date: values.received_date,
                order_date: values.order_date,
                total_running_qty: values.total_running_qty,
                total_running_ton: values.total_running_ton ?? 0,
                drawing_no: values.drawing_no,
                eligible_bloster: values.eligible_bloster,
                eligible_for_press: values.eligible_for_press,
                purchase_price: values.purchase_price,
                run_under_deviation: values.run_under_deviation,
                run_under_deviation_inactive: values.run_under_deviation_inactive,
                run_under_deviation_reason: values.run_under_deviation_reason,
                ownership: values.ownership,
                is_active: values.is_active,
                remarks: values.remarks,
            };
            const response = await DieToolService.addDieTool(textPayload);
            return response.data; // Assuming response contains the created die group data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const updateDieTool = createAsyncThunk(
    'dieTool/updateDieTool',
    async ({ id, values }, thunkAPI) => {
        try {
            const formPayload = {
                die: typeof values.die === 'object' ? values.die.value : values.die,
                tool_number: values.tool_number,
                current_kg: values.current_kg,
                die_size: values.die_size, // Ensure numeric values
                die_cavity: values.die_cavity,
                developer: values.developer,
                die_option: values.die_option,
                eligible_for_press: values.eligible_for_press,
                diameter: values.diameter,
                thickness: values.thickness,
                backer_number: values.backer_number,
                rac_no: values.rac_no,
                row_no: values.row_no,
                column_no: values.column_no,
                die_location: values.die_location,
                developer_ref_no: values.developer_ref_no,
                received_date: values.received_date,
                order_date: values.order_date,
                total_running_qty: values.total_running_qty,
                total_running_ton: values.total_running_ton ?? 0,
                drawing_no: values.drawing_no,
                eligible_bloster: values.eligible_bloster,
                purchase_price: values.purchase_price,
                run_under_deviation: values.run_under_deviation,
                run_under_deviation_inactive: values.run_under_deviation_inactive,
                run_under_deviation_reason: values.run_under_deviation_reason,
                ownership: values.ownership,
                is_active: values.is_active,
                remarks: values.remarks,
            };

            const response = await DieToolService.updateDieTool(id, formPayload);

            return response.data; // Return the updated die group data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteDieTool = createAsyncThunk(
    'dieTool/deleteDieTool',
    async (id, thunkAPI) => {
        try {
            await DieToolService.deleteDieTool(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unArchiveDieTool = createAsyncThunk(
    'dieProfile/unArchiveDieTool',
    async (id, thunkAPI) => {
        try {
            await DieToolService.unArchiveDieToolRecord(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

const initialState = {
    data: [], // List
    list: [],
    toolsList: [],
    loading: false,
    totalPages: 0,
    currentPage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    hasMore: true,
};


const dieToolSlice = createSlice({
    name: 'die-tool',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetDieToolData: (state) => {
            state.data = []; // This will clear the list
        },
        resetDieToolList: (state) => {
            state.list = []; // This will clear the list
        },
        resetToolsList: (state) => {
            state.toolsList = []; // This will clear the list
        },
        resetCurrentToolPage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchDieToolList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDieToolList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];
                state.totalPages = action.payload.totalPages;
                state.totalRecord = action.payload.count;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchDieToolList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(fetchArchivedDieToolist.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedDieToolist.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedDieToolist.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });

        builder
            .addCase(fetchDieToolDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDieToolDetails.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchDieToolDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(fetchDieToolById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDieToolById.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchDieToolById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(fetchDieToolByDieProfileId.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDieToolByDieProfileId.fulfilled, (state, action) => {
                state.data = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.totalPages = action.payload.totalPages;
                state.totalRecord = action.payload.count;
                state.currentPage = fetchedPage + 1 || 1;
                state.toolsList = [...state.toolsList, ...action.payload.results.data];
                state.hasMore = action.payload.results.data.length >= 10;
            })
            .addCase(fetchDieToolByDieProfileId.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(createDieTool.pending, state => {
                state.status = 'loading';
            })
            .addCase(createDieTool.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createDieTool.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(updateDieTool.pending, state => {
                state.status = 'loading';
            })
            .addCase(updateDieTool.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(updateDieTool.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(deleteDieTool.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteDieTool.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteDieTool.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveDieTool.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveDieTool.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveDieTool.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetDieToolList, resetDieToolData, resetToolsList, resetCurrentToolPage } = dieToolSlice.actions;
const { reducer } = dieToolSlice;
export default reducer;
